import { Type } from "@google/genai"

export const geminiResponseSchema = {
    type: Type.OBJECT,
    properties: {
        companyRegistrationNumber: {
            type: Type.STRING,
            nullable: false
        },
        companyName: {
            type: Type.STRING,
            nullable: false
        },
        invoiceNumber: {
            type: Type.STRING,
            nullable: false
        },
        invoiceDateTime: {
            type: Type.STRING,
            format: 'date-time'
        },
        originalInvoiceNumber: {
            type: Type.STRING,
            nullable: true
        },
        invoiceItems: {
            type: Type.ARRAY,
            items: {
                type: Type.OBJECT,
                properties: {
                    itemDescription: {
                        type: Type.STRING
                    },
                    itemPrice: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemQuantity: {
                        type: Type.INTEGER,
                        format: 'int64',
                        default: 1,
                        nullable: false
                    },
                    itemSubtotal: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemTaxType: {
                        type: Type.STRING,
                    },
                    itemTaxRate: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemTaxAmount: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemFeeRate: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemFeeAmount: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemDiscountRate: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    },
                    itemDiscountAmount: {
                        type: Type.NUMBER,
                        format: 'double',
                        default: 0,
                        nullable: false
                    }
                }
            }
        },
        additionalDiscountAmount: {
            type: Type.NUMBER,
            format: 'double',
            default: 0,
            nullable: false
        },
        additionalFeeAmount: {
            type: Type.NUMBER,
            format: 'double',
            default: 0,
            nullable: false
        },
        totalSalesTaxAmount: {
            type: Type.NUMBER,
            format: 'double',
            default: 0,
            nullable: false
        },
        totalPayableAmount: {
            type: Type.NUMBER,
            format: 'double',
            default: 0,
            nullable: false
        },
        totalRoundingAmount: {
            type: Type.NUMBER,
            format: 'double',
            default: 0,
            nullable: false
        }
    },
    propertyOrdering: [
        'companyRegistrationNumber',
        'companyName',
        'invoiceNumber',
        'invoiceDateTime',
        'invoiceItems',
        'additionalDiscountAmount',
        'additionalFeeAmount',
        'totalSalesTaxAmount',
        'totalPayableAmount',
        'totalRoundingAmount'
    ]
}